<p-dialog
  [(visible)]="visible"
  (onHide)="handleHide()"
  [modal]="true"
  [header]="title"
  [style]="{ width: width || '450px' }"
  [closable]="closable"
>
  <ng-template *ngIf="!!title" pTemplate="header">
    <h3>{{ title }}</h3>
  </ng-template>
  <ng-template pTemplate="content">
    <ng-content></ng-content>
  </ng-template>
  <ng-template pTemplate="footer">
    <ng-container *ngFor="let action of actions">
      <button
        pButton
        type="button"
        [label]="action.label"
        [icon]="action.icon"
        [class]="action.styleClass"
        [disabled]="action.disabled"
        (click)="action.action()"
        style="margin-right: 0.5rem;"
      ></button>
    </ng-container>
  </ng-template>
</p-dialog>